import { useState, React, useRef, useEffect } from 'react';
import './homepage.css';
import '../App.css';
import VideoModal from './VideoModal';
import BottomBar from './BottomBar';
import CircularMenu from './CircularMenu';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './CardSlider.css';

const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const CardSlider = ({ images }) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const carouselRef = useRef(null);

  const scrollLeft = () => {
    carouselRef.current.scrollLeft -= carouselRef.current.offsetWidth / 3;
  };

  const scrollRight = () => {
    carouselRef.current.scrollLeft += carouselRef.current.offsetWidth / 3;
  };

  return (
    <div className="homepagedark">
      <div className="bg1">
        <div className="bg-item"></div>
        <div className="line-group">
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
        </div>
      </div>
      <div className="ololade-group">
        <div className="ololade2">
          <span>CERTIFICATES</span>
          <span className="span2">.</span>
        </div>
      </div>
      <div className="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
          <div style={{ position: 'absolute',     top: 5,
    left: 680, }}>
            <button className="download-btndark" onClick={handleOpenModal}>
              <div className="download-btndark-child"></div>
              <div className="download-btndark-item"></div>
              <div className="resume1">Visume</div>
              <VideoModal
                show={showModal}
                handleClose={handleCloseModal}
                videoSrc=""
              />
            </button>
          </div>
          <div style={{ position: 'absolute',     top: 5,
    left: 830, }}>
            <button className="download-btndark" onClick={handleDownload}>
              <div className="download-btndark-child"></div>
              <div className="download-btndark-item"></div>
              <div className="resume1">Resume</div>
              <img className="akar-iconsdownload1" alt="" src="akariconsdownload.svg" />
            </button>
          </div>
        </div>
      </div>

      {/* <div className="wrapper">
        <i id="left" className="fa-solid fa-angle-left" onClick={scrollLeft}></i>
        <ul className="carousel" ref={carouselRef}>
          {images.map((src, index) => (
            <li className="card" key={index}>
              <div className="img">
                <img src={src} alt={`img-${index}`} draggable="false" />
              </div>
              <h2>Card Title {index + 1}</h2>
              <span>Card Subtitle</span>
            </li>
          ))}
        </ul>
        <i id="right" className="fa-solid fa-angle-right" onClick={scrollRight}></i>
      </div> */}
      <div className="wrapper">
      <i id="left" className="fa-solid fa-angle-left" onClick={scrollLeft}></i>
      <ul className="carousel" ref={carouselRef}>
        {images.map((image, index) => (
          <li className="card" key={index}>
            <a href={image.certificateLink} target="_blank" rel="noopener noreferrer">
            <div className="img">
              <img src={image.src} alt={`img-${index}`} draggable="false" />
            </div></a>
            <h2>{image.name}</h2>
            <span>
              Click on Image to View Certificate*
            </span>
          </li>
        ))}
      </ul>
      <i id="right" className="fa-solid fa-angle-right" onClick={scrollRight}></i>
    </div>

      <BottomBar />

      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <div style={{ position: 'absolute', top: -40, bottom: 0, right: 50 }}>
          <CircularMenu />
        </div>
      </div>
    </div>
  );
};

export default CardSlider;
